import { dimensionValueStore } from "../../../../store/dimension.value";
import { DimensionTypes } from "../../../../types/dimensions";
import type { RequestParameter } from "../../DropdownDimensionHelpers";

export enum DataDimensionValueType {
    NONE = "none",
    JSON = "json",
    REQUEST_PARAMETER = "requesterParameter",
    LOGIC = "logic",
}

export abstract class DataDimensionValue {
    id: string;
    abstract config;
    abstract type: string;

    constructor(dimensionId: string, _config: DataDimensionValueBaseConfig) {
        this.id = dimensionId;
    }

    protected abstract handler(input: DataDimensionInput): string;

    setValue(input: DataDimensionInput): void {
        const value = this.handler(input);
        dimensionValueStore.getState().setData(
            this.id,
            {
                type: DimensionTypes.DATA,
                value,
            },
            this.getRequestParameter(input, value),
        );
    }

    getRequestParameter(
        _input: DataDimensionInput,
        handlerOutput: string,
    ): RequestParameter {
        return {
            [this.id]: handlerOutput,
        };
    }
}

export interface DataDimensionValueBaseConfig {
    type: DataDimensionValueType;
}

export type DataDimensionInput = object | string | number;
